export function useTokenExpiry(store, router) {
    const checkExpiry = () => {
        const expiresAt = store.token_expires_at
        if (expiresAt && Math.floor(Date.now() / 1000) > expiresAt) {
            console.warn('[Auto-Logout] Session expired.')
            store.logout()
            router.push({ name: 'login', query: { error: 'session_expired' } })
        }
    }

    // Check immediately and then every minute
    checkExpiry()
    setInterval(checkExpiry, 60 * 1000)
}
